import log from 'loglevel';

if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENV === 'STAGING') {
  log.setLevel('ERROR');
  
  // Override console completely
  console.log = log.debug;
  console.info = log.info;
  console.warn = log.warn;
  console.error = log.error;
} else {
  log.setLevel('DEBUG'); // Show all logs in development
}

export default log;